module.exports = __webpack_public_path__ + "static/media/brand11.1f3b47a7.png";